import { AttributesMixin, define, Linked, type } from "@type-r/models";
import { asDate, Input } from "lqx-react/lib";
import { FilterModel } from "./base-filter-model";
import * as React from 'react';
import { useBoundLink } from "@type-r/react";
import { useThrottle } from "@linked/controls";
import { styled } from "@material-ui/core/styles";

export interface DateFilter extends AttributesMixin<typeof DateFilter>{}
@define
export class DateFilter extends FilterModel {
    static attributes = {
        ...FilterModel.attributes,
        date : type( Date ).null
    }

    delete() {
        this.date = undefined;
    }

    asLabel() {
        return asDate(this.date);
    }
}
export const SelectDate = ({ $date } : {
    $date?: Linked<Date>
}) =>{

    const $dateValue = useBoundLink( $date )
    .onChange(
        useThrottle(
            x => { $date.set( x ) },
            1000,
            [ $date.value ]
        )
    );

  return (
    <>
        <DateInput $value={ $dateValue } date />
    </>
  )
}

export const EnterDate = ({ onEnter, filterValue }: {onEnter: any, filterValue: DateFilter}) => {

    filterValue.onChanges((x) => {
        if (filterValue.isValid())
            onEnter(x)
    });

    return (
        <SelectDate $date={filterValue.$.date} />
    )
}

const DateInput = styled(Input)({
    margin: "5px 10px 5px 0",
    border: "1px solid #c4c4c4",
    borderRadius: "4px"
  });

const padTo2Digits = (num) => num.toString().padStart(2, '0');

export const formatDateFilter = (date) => {
    return [
      date.getFullYear(),
      padTo2Digits(date.getMonth() + 1),
      padTo2Digits(date.getDate()),
    ].join('-');
};
